import { fetchHandler, oneLimiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postReadMessage = (accountId, messageId) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/messages/${messageId}/read`)

    return oneLimiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}